import 'material-design-icons-iconfont/dist/material-design-icons.css'
import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import Country from '@/components/Country.json';
//import colors from 'vuetify/lib/util/colors';

Vue.use(Vuetify);


export default new Vuetify({
  icons: {
    iconfont: 'mdi', // default - only for display purposes
  },
  theme: {
    themes: {
      light: {
        primary: '#f7a71c', // yellow
        secondary: '#4b9465', //green
        warning: '#dae4ee',
        danger: '#00b85e'
        //warning: colors.red, // #3F51B5
      },
    },
  },
  data: () => ({
    Country: Country,
    country: ''
  })
});
